import angular from 'angular';

export default function RosterPrintPayloadReplacer(dateFilter) {
  'ngInject';

  function _isShift(obj) {
    return obj.type === 'shift';
  }

  function _isCalendarGroup(obj) {
    return Boolean(obj.key && obj.totals);
  }

  function _isDate(obj, prop) {
    return (prop === 'dtstartLocal' || prop === 'dtstart' || prop === 'dtend') && obj[prop];
  }

  const ROSTER_RELEVANT_EVENT_PROPS = [
    'dtstartLocal',
    'dtstart',
    'dtend',
    'user',
    'location',
    'position',
    'tags',
    'openEnd',
    'rosterStatus',
    'shiftTimeLabel',
    'shiftHiddenEndTimeLabel',
    'sortKey',
  ];

  const ROSTER_RELEVANT_GROUP_PROPS = ['key', 'events', 'category'];

  // eslint-disable-next-line complexity
  return function reportsPrintPayloadReplacer(key, value) {
    // event with timesheets
    if (
      (_isShift(this) && !ROSTER_RELEVANT_EVENT_PROPS.includes(key)) ||
      (_isCalendarGroup(this) && !ROSTER_RELEVANT_GROUP_PROPS.includes(key))
    ) {
      return undefined;
    }

    if (['userGroups', 'tags'].includes(key) && value && value.length) {
      return value.map((i) => ({
        id: i.id,
        name: i.name,
      }));
    }

    if (['location', 'position', 'user'].includes(key) && value) {
      const redacted = {
        id: value.id,
        name: value.name,
      };

      if (key === 'position') {
        redacted.color = value.color;
      }

      if (key === 'user') {
        redacted.fullname = value.fullname;
        redacted.name = value.name;
        redacted.lastname = value.lastname;
        redacted.employeeId = value.employeeId;
        redacted.groups = value.groups;
      }

      return redacted;
    }

    if (_isDate(this, key)) {
      let date = value;
      if (!angular.isDate(value)) {
        date = new Date(value);
      }

      if (key === 'dtstartLocal') {
        return this[key].toISOString();
      }

      return dateFilter(date, 'yyyy-MM-ddTHH:mm:00');
    }

    return value;
  };
}
